// map-event.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapEventService {
  private deviceClickSource = new Subject<string>();
  
  deviceClick$ = this.deviceClickSource.asObservable();
  
  emitDeviceClick(deviceId: string): void {
    this.deviceClickSource.next(deviceId);
  }
}